<template>
  <vuestic-sidebar v:hidden="isOpen" v-if="isShow">
    <template slot="menu">
      <!-- <sidebar-link
        :to="{ name: 'Dashboard' }"
      >
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-dashboard"
          ></span>
          <span>{{ $t("menu.dashboard") }}</span>
        </span>
      </sidebar-link> -->

      <sidebar-link-group>
        <span slot="title">
          <span
              class="sidebar-menu-item-icon vuestic-icon vuestic-icon-forms"
          ></span>
          <span>{{ $t("menu.paymentOrder") }}</span>
        </span>
        <!-- v-if="permissions[pageName.transactions]" -->
        <sidebar-link
          :to="{ name: 'PaymentOrder' }"
        >
          <span slot="title" class="temp">
            <span class="circle"></span>
            <span style="font-size:16px;">{{ $t("menu.paymentOrderList") }}</span>
          </span>
        </sidebar-link>
        <sidebar-link
           v-if="permissions['Download']"
          :to="{ name: 'PaymentOrderDownload' }"
        >
          <span slot="title" class="circle-temp">
            <span class="circle"></span>
            <span style="font-size:16px;">{{ $t("menu.paymentOrderDownload") }}</span>
          </span>
        </sidebar-link>
      </sidebar-link-group>

      <!-- <sidebar-link-group>
        <span slot="title">
          <span
              class="sidebar-menu-item-icon vuestic-icon vuestic-icon-statistics"
          ></span>
          <span>{{ $t("menu.recurrings") }}</span>
        </span>
        <sidebar-link
          :to="{ name: 'Recurring' }"
        >
          <span slot="title" class="temp">
            <span class="circle"></span>
            <span style="font-size:16px;">{{ $t("menu.recurringsList") }}</span>
          </span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'RecurringDownload' }"
        >
          <span slot="title" class="circle-temp">
            <span class="circle"></span>
            <span style="font-size:16px;">{{ $t("menu.recurringsDownload") }}</span>
          </span>
        </sidebar-link>

      </sidebar-link-group> -->
      <sidebar-link
      v-if="permissions[pageName.recurring]"
        :to="{ name: 'Recurring' }"
      >
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-graph"
          ></span>
          <span>{{ $t("menu.recurrings") }}</span>
        </span>
      </sidebar-link>
      <sidebar-link
        v-if="permissions[pageName.virtualAccount]"
        :to="{ name: 'VirtualAccount' }"
      >
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-graph"
          ></span>
          <span>{{ $t("menu.virtualAccount") }}</span>
        </span>
      </sidebar-link>
      <sidebar-link
        v-if="permissions[pageName.report]"
        :to="{ name: 'Report' }"
      >
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-graph"
          ></span>
          <span>{{ $t("menu.report") }}</span>
        </span>
      </sidebar-link>
      <sidebar-link
        v-if="permissions[pageName.userManagement]"
        :to="{ name: 'UserManagement' }"
      >
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-user"
          ></span>
          <span>{{ $t("menu.userManagement") }}</span>
        </span>
      </sidebar-link>
      <sidebar-link
        v-if="permissions[pageName.appManagement]"
        :to="{ name: 'AppManagement' }"
      >
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-ui-elements"
          ></span>
          <span>{{ $t("menu.appManagement") }}</span>
        </span>
      </sidebar-link>
      <!-- settlement -->
      <!-- <sidebar-link :to="{ name: 'Settlement' }">
      <span slot="title">
        <span class="sidebar-menu-item-icon vuestic-icon vuestic-icon-rmb"></span>
        <span>{{ $t('menu.Settlement') }}</span>
      </span>
    </sidebar-link> -->
      <sidebar-link-group v-if="permissions[pageName.finance] && isNew">
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-dollar"
          ></span>
          <span>{{ $t("menu.FinancialManagement") }}</span>
        </span>
        <sidebar-link
          v-if="permissions[pageName.finance]"
          :to="{ name: 'FinancialManagement' }"
        >
          <span slot="title" class="temp">
            <span class="circle"></span>
            <span style="font-size:16px;">{{ $t("menu.withdrawals") }}</span>
          </span>
        </sidebar-link>
        <sidebar-link
          v-if="permissions[pageName.finance]"
          :to="{ name: 'BankAccounts' }"
        >
          <span slot="title" class="circle-temp">
            <span class="circle"></span>
            <span style="font-size:16px;">{{ $t("menu.bankAccounts") }}</span>
          </span>
        </sidebar-link>
      </sidebar-link-group>

      <sidebar-link
        v-if="permissions[pageName.finance] && !isNew"
        :to="{ name: 'FinancialManagement' }"
      >
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-dollar"
          ></span>
          <span>{{ $t("menu.FinancialManagement") }}</span>
        </span>
      </sidebar-link>

      <sidebar-link
        v-if="permissions[pageName.merchantKyc]"
        :to="{ name: 'MerchantKYC' }"
      >
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-files"
          ></span>
          <span>{{ $t("menu.kyc") }}</span>
        </span>
      </sidebar-link>
      <!-- <sidebar-link
        v-if="permissions[pageName.wayBill]"
        :to="{ name: 'WayBillList' }"
      >
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-maps"
          ></span>
          <span>{{ $t("menu.wayBill") }}</span>
        </span>
      </sidebar-link> -->
      <sidebar-link-group v-if="permissions[pageName.wayBill]">
        <span slot="title">
          <span
              class="sidebar-menu-item-icon vuestic-icon vuestic-icon-forms"
          ></span>
          <span>{{ $t("menu.wayBill") }}</span>
        </span>
        <sidebar-link
          v-if="permissions[pageName.wayBill]"
          :to="{ name: 'WayBillList' }"
        >
          <span slot="title" class="temp">
            <span class="circle"></span>
            <span style="font-size:16px;">{{ $t("menu.paymentOrderList") }}</span>
          </span>
        </sidebar-link>
        <sidebar-link
          v-if="permissions[pageName.wayBill]"
          :to="{ name: 'BatchUpload' }"
        >
          <span slot="title" class="circle-temp">
            <span class="circle"></span>
            <span style="font-size:16px;">{{ $t("menu.uploadHistory") }}</span>
          </span>
        </sidebar-link>
        <sidebar-link
          v-if="permissions[pageName.wayBill]"
          :to="{ name: 'DownloadLog' }"
        >
          <span slot="title" class="circle-temp">
            <span class="circle"></span>
            <span style="font-size:16px;">{{ $t("menu.downloadHistory") }}</span>
          </span>
        </sidebar-link>

      </sidebar-link-group>
    </template>
  </vuestic-sidebar>
</template>

<script>
import VuesticSidebar from '../../../vuestic-theme/vuestic-components/vuestic-sidebar/VuesticSidebar'
import SidebarLink from './components/SidebarLink'
import SidebarLinkGroup from './components/SidebarLinkGroup'
import { request } from '@/utils/utils.js'
import UserManagementVue from '../../UserManagement/UserManagement.vue'
import pageName from '../../NewUser/pageNames'
import store from '@/store'

export default {
  name: 'app-sidebar',
  data () {
    return {
      isShow: true,
      uid: '',
      token: localStorage.getItem('Authorization'),
      pageName: pageName,
      permissions: {
        // [pageName.transactions]: false,
        [pageName.report]: false,
        [pageName.appManagement]: false,
        [pageName.finance]: false,
        [pageName.merchantKyc]: false,
        [pageName.userManagement]: false,
        [pageName.wayBill]: false,
        [pageName.recurring]: false,
        [pageName.virtualAccount]: false,
        [pageName.download]: false
      },
      locationHost: '',
      isNew: true
    }
  },
  components: {
    VuesticSidebar,
    SidebarLink,
    SidebarLinkGroup
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  created() {
    this.locationHost = location.host;
    this.initSidebar()
  },
  mounted () {
    if (Object.prototype.toString.call(this.$store.getters.user.permissions) === '[object Object]') {
      this.isShow = false
      let storePerm = {...this.$store.getters.user.permissions}
      storePerm['Recurring'] = true
      // 新哥-Payin商户后台 merchant kyc的菜单隐藏一下 20231121
      storePerm['Merchant KYC'] = false
      if (process.env.VUE_APP_WEBSETE_SIGN === 'lt') {
        storePerm['WayBill'] = false
        storePerm['Recurring'] = false
      }
      for (let item in storePerm) {
        if (this.permissions[item] !== undefined) {
          this.permissions[item] = !!storePerm[item]
        }
      }
      this.isShow = true
    }
  },
  methods: {
    initSidebar () {
      let token = localStorage.getItem('Authorization')
      request({
        method: 'post',
        url: 'api/dashboard/app/user/query?access_token=' + token
      }).then(res => {
        const { code, data } = res.data
        if (code === '10000') {
          const { show_new_withdrawal } = data
          // let show_new_withdrawal = false
          this.isNew = !!show_new_withdrawal
          localStorage.setItem("show_new_withdrawal", show_new_withdrawal);
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.spinner {
  position: absolute;
  left: 130px;
  top: 150px;
}
.vuestic-icon-rmb:before {
  font: normal normal normal 19px/1 FontAwesome;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  width: 19px;
  text-align: center;
  content: "\F157";
}
.vuestic-icon-dollar:before {
  font: normal normal normal 19px/1 FontAwesome;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  width: 19px;
  text-align: center;
  content: "\F155";
}
.circle-temp{
  position: relative;
}
.circle{
  position: absolute;
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 10px;
  background-color: #fff;
  margin-right: 10px;
  margin-left: -18px;
  top: 50%;
  margin-top: -3px;
}
/deep/ .sidebar-link-group .sidebar-submenu {
  height: fit-content!important;
}
</style>
